


<div class="container mx-auto d-flex flex-column-reverse flex-lg-row gap-3">

    <form class="form-box mb-5 my-lg-5 p-4 w-100" [formGroup]="form">


        <div class="mb-3">
            <label for="input_5" class="form-label">{{"Service needed" | translate}}</label>
            <select type="text" class="form-control direction-left text-start" id="input_5" formControlName="packge_id">
                <option value="{{ package.id }}" *ngFor="let package of packages">{{ package.name }}</option>
            </select>
        </div>

        <div class="mb-3">
            <label for="input_6" class="form-label">{{"Payment type" | translate}}</label>
            <select type="text" class="form-control direction-left text-start" id="input_6" formControlName="payment_type_id" (change)="payment_method_changed(payment_select);" #payment_select>
                <option value="{{ method.id }}" *ngFor="let method of payment_methods">{{ method.name }}</option>
            </select>
        </div>


        <div class="mb-3" *ngIf="is_cash">
            <label for="formFileLg" class="form-label">{{"Transfer receipt" | translate}}</label>
            <input class="form-control form-control-lg" style="direction: ltr;" id="formFileLg" type="file" (change)="file_upload($event);">
        </div>


        <div class="mb-3">
            <button type="button" class="btn btn-warning" (click)="create_package();">{{"Send" | translate}}</button>
        </div>

    </form>

    <div>

        <div class="d-flex justify-content-center">
            <img src="../../assets/images/buy_package.svg" alt="ecommerce image" class="cover-img my-5">
        </div>

    </div>

</div>
